import { Grid } from '@mui/material'
import { AuthLayout } from 'components'
import { AuthTitle } from 'containers/Pay/Pay'
import { AuthMain, AuthWrapper } from '../SignIn'
import { Form } from './component'
import { WELCOME_DESCRIPTION, WELCOME_TITLE } from 'config'

export function ForgotEmail(): JSX.Element {
    return (
        <AuthLayout
            title={WELCOME_TITLE}
            desc={WELCOME_DESCRIPTION}
            isAuthPage={true}
        >
            <AuthWrapper isAuthPage={true}>
                <Grid
                    mb={5}
                    container
                    justifyContent={'center'}
                    sx={{ minHeight: 'calc(100vh - 470px)' }}
                >
                    <Grid item xs={12} md={6}>
                        <AuthMain isRounded={true} >
                            <AuthTitle title="Forgot Email Address" />
                            <Form />
                        </AuthMain>
                    </Grid>
                </Grid>
            </AuthWrapper>
        </AuthLayout>
    )
}
